import React from 'react'
import ProfileUserCard from './ProfileUserCard';
import ProfileAdditionalInfo from './ProfileAdditionalInfo';

export const Profile = () => {
    return (
        <div className='gap-4 profile-card'>
            <ProfileUserCard mode='PROFILE' />
            <ProfileAdditionalInfo mode="PROFILE" />
        </div>
    );
}
export default Profile;